import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';

@Component({
  selector: 'app-change-karma-description',
  templateUrl: './change-karma-description.component.html',
  styleUrls: ['./change-karma-description.component.css']
})
export class ChangeKarmaDescriptionComponent implements OnInit {
  changeLog = '';
  modalLogWindow;
  actionType; 
  activeUserId;
  currentValue = 1;

  constructor(public activeModal: NgbActiveModal, private adminService: AdminService) {
  }

  ngOnInit() {
  }

  action(action, id) {
    this.actionType = action;
    this.activeUserId = id;
  }

  disabledBtn() {
    return this.changeLog.length >= 3;
  }

  plus(){
    this.currentValue++
  }

  minus(){
    if(this.currentValue > 1) {
      this.currentValue--
    }
  }

  setChangeLog() {
    const group = {
      userID: this.activeUserId,
      description: this.changeLog, 
      direction: this.actionType,
      amount: this.currentValue
    };
    this.adminService.changeKarma(group).subscribe(
      (response) => {
        this.activeModal.close('continue');
      },
      () => {
      });
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/change-karma-description/change-karma-description.component.ts